import GButton from "../../components/ui/base/GButton"
import useMainStore from "../../store/mainState";
import { useMutation, useQuery } from "@apollo/client";
import { BONUS_ELIGIBILITY_QUERY, GET_BONUS } from "../../graphql/bonuses";
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import DailyPopup from "../../components/ui/popup/DailyPopup";
import HourlyPopup from "../../components/ui/popup/HourlyPopup";
import { useTranslation } from "react-i18next";

type DailyEligableData = {
    code: string;
    eligible: boolean;
    next: string | null;
    reason: string;
    __typename: string;
}

const Bonuses = () => {
    const { t } = useTranslation();
    const [dailyEligableData, setDailyEligableData] = useState<DailyEligableData | null>(null);
    const [hourlyEligableData, setHourlyEligableData] = useState<DailyEligableData | null>(null);
    const { setIsSignUpOpen, user, setIsLoading } = useMainStore();
    const [dailyBonusPopupVisible, setDailyBonusPopupVisible] = useState(false);
    const [hourlyBonusPopupVisible, setHourlyBonusPopupVisible] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(0);
    const { loading: loadBonusEligibility, error: bonusEligibilityError, data: bonusEligibilityData, refetch: refetchBonusEligibility } = useQuery(BONUS_ELIGIBILITY_QUERY);
    const { data: getBonusData, loading: getBonusLoading, error: getBonusError } = useQuery(GET_BONUS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            id: 3
        }
    })

    const onClaimDailyBonus = useCallback(async () => {
        if (!user) {
            setIsSignUpOpen(true)
        } else {
            setIsLoading(true)
            await refetchBonusEligibility()
            setIsLoading(false)
            setDailyBonusPopupVisible(true);
        }
    }, [user]);

    const onClaimHourlyBonus = useCallback(async () => {
        if (!user) {
            setIsSignUpOpen(true)
        } else {
            setIsLoading(true)
            await refetchBonusEligibility()
            setIsLoading(false)
            setHourlyBonusPopupVisible(true);
        }
    }, [user]);

    useLayoutEffect(() => {
        setIsLoading(true)
    }, [])

    useEffect(() => {
        if (user) {
            const dailyEligableData = bonusEligibilityData?.bonusEligibility?.find((item: any) => item.code === 'DAILY_LOGIN_BONUS');
            setDailyEligableData(dailyEligableData);
            const hourlyEligableData = bonusEligibilityData?.bonusEligibility?.find((item: any) => item.code === 'HOURLY_SPIN');
            setHourlyEligableData(hourlyEligableData);
        }
    }, [bonusEligibilityData, user]);

    useEffect(() => {
        if (imageLoaded === 4) {
            setIsLoading(false)
        }
    }, [imageLoaded])
    return (
        <div>
            <section className='flex flex-row bg-[#0d1225] flex items-center rounded-[25px]'>

                {/* <div className="bg-[#0d1225] flex items-center rounded-[25px] "> */}
                <div className="flex-[3] my-[10px] ml-[18px] lg:my-[24px] lg:ml-[55px] xl:my-[34px] xl:ml-[75px] flex flex-col">
                    <h1 className="text-[#fff] text-[25px] md:text-[45px] uppercase font-[600]">{t('bonuses.unlock')} <span className="text-[#0086D3]">{t('bonuses.endless')}</span> {t('bonuses.benefits')}</h1>
                    <p className="text-[#B3BEC1] text-[15px] md:text-[20px]">{t('bonuses.joinDescription')}</p>
                    <p className="text-[#B3BEC1] text-[15px] md:text-[20px]">{t('bonuses.luckAndReward')}</p>
                    {!user && <GButton onClick={() => { setIsSignUpOpen(true) }} className="py-[10px] md:px-[50px] px-[20px] mt-[20px] w-[250px]" textStyle="!text-[16x] md:!text-[20px]">{t('common.signUp')}</GButton>}
                </div>
                <div className="flex-[2]">
                    <img onLoad={() => setImageLoaded(imageLoaded + 1)}
                        className="flex-1 h-[100%]" src={require("../../assets/images/bonus.png")} />
                </div>
                {/* </div> */}
            </section>
            <div className="flex items-center gap-[30px] justify-center mt-[50px] mb-[100px]">
                <div className="flex items-center gap-[20px] flex-wrap  justify-center align-center">
                    <div className="bg-[#0086D3] rounded-[25px] md:w-[40px] md:h-[40px] w-[25px] h-[25px] flex items-center md:text-[20px] text-[12px] justify-center text-[#000] font-[800]">01</div>
                    <span className="text-[#fff] md:text-[20px] text-[12px] font-[800] !text-center">{t('bonuses.step1')}</span>
                </div>
                <div className="h-[1px] w-[60px] bg-[#E4EAF019]" />
                <div className="flex items-center gap-[20px] flex-wrap justify-center align-center">
                    <div className="bg-[#0086D3] rounded-[25px] md:w-[40px] md:h-[40px] w-[25px] h-[25px] flex items-center md:text-[20px] text-[12px] justify-center text-[#000] font-[800]">02</div>
                    <span className="text-[#fff] md:text-[20px] text-[12px] font-[800] !text-center">{t('bonuses.step2')}</span>
                </div>
                <div className="h-[1px] w-[60px] bg-[#E4EAF019]" />
                <div className="flex items-center gap-[20px] flex-wrap justify-center align-center">
                    <div className="bg-[#0086D3] rounded-[25px] md:w-[40px] md:h-[40px] w-[25px] h-[25px] flex items-center md:text-[20px] text-[12px] justify-center text-[#000] font-[800]">03</div>
                    <span className="text-[#fff] md:text-[20px] text-[12px] font-[800] !text-center">{t('bonuses.step3')}</span>
                </div>
            </div>
            <div className="flex items-stretch justify-center gap-[5%] md:gap-[10%] mx-[5%] md:mx-[2%]">
                <div className="w-[50%] flex flex-col justify-center items-start">
                    <p className="md:text-[35px] text-[18px] text-[#fff] font-[800]">{t('bonuses.levelUpTitle')} <br /> {t('bonuses.levelUpTitleHighlight')}</p>
                    <p className="md:text-[18px] text-[12px] text-[#fff] md:my-[25px] my-[15px]">{t('bonuses.levelUpDesc')} <span className="text-[#0086D3]">{t('bonuses.cash')}</span> {t('bonuses.rewards')} <span className="text-[#0086D3]">{t('bonuses.freeLuckySpins')}</span>!<br />
                        {t('bonuses.higherLevel')}</p>
                    <button onClick={() => { }} className="p-[0] md:text-[18px] text-[12px] text-[#0086D3]">{t('bonuses.levelUpDetails')} &#62;</button>
                    {!user && <GButton textStyle="!text-[#000] !font-[800] !text-[12px] md:!text-[20px]" onClick={() => { setIsSignUpOpen(true) }} className="md:py-[10px] py-[5px] md:px-[10px] px-[5px] mt-[40px] md:w-[250px] w-[155px]">{t('bonuses.unlockLevelUp')}</GButton>}
                </div>
                <div className="flex items-stretch w-[50%]">
                    <img
                        onLoad={() => setImageLoaded(imageLoaded + 1)}
                        src={require("../../assets/images/levelUpBonus.png")}
                        className="object-contain w-full h-full"
                        alt="Level Up Bonus"
                    />
                </div>
            </div>
            <div className="flex items-stretch justify-center gap-[5%] md:gap-[10%] mx-[5%] md:mx-[2%] my-[20px]">
                <div className="flex items-stretch w-[50%]">
                    <img
                        onLoad={() => setImageLoaded(imageLoaded + 1)}
                        src={require("../../assets/images/pngtree.png")}
                        className="object-contain w-full h-full"
                        alt="Level Up Bonus"
                    />
                </div>
                <div className="w-[50%] flex flex-col justify-center items-start">
                    <p className="md:text-[35px] text-[18px] text-[#fff] font-[800]">{t('bonuses.rakebackTitle')} <br /> {t('bonuses.rakebackTitleHighlight')}</p>
                    <p className="md:text-[18px] text-[12px] text-[#fff] md:my-[25px] my-[15px]">{t('bonuses.rakebackDesc')}</p>
                    <button onClick={() => { }} className="p-[0] md:text-[18px] text-[12px] text-[#0086D3]">{t('bonuses.rakebackDetails')} &#62;</button>
                    {!user && <GButton textStyle="!font-[800] !text-[12px] md:!text-[20px]" onClick={() => { setIsSignUpOpen(true) }} className="md:py-[10px] p-[5px] md:px-[10px] mt-[40px] md:w-[200px] w-[155px]">{t('bonuses.unlockRakeback')}</GButton>}
                </div>

            </div>
            <p className="text-[#fff] md:text-[30px] text-[18px] font-[800] capitalize text-center pb-[20px]">{t('bonuses.freePerks')} <span className="text-[#0086D3]">{t('bonuses.free')} </span>{t('bonuses.perks')}</p>
            <div className="flex items-stretch justify-center gap-[5%]">
                <button onClick={() => { onClaimDailyBonus() }} className="bg-bonus-bg bg-cover bg-center bg-no-repeat rounded-[25px] p-[15px] flex flex-col" >
                    <div className="flex  justify-center flex-wrap">
                        <div className="flex  justify-around flex-col px-[10px]">
                            <p className="text-[#0086D3] md:text-[20px] text-[12px] font-[500]">{t('bonuses.everyDay')}</p>
                            <p className="text-[#fff] md:text-[30px] text-[18px] font-[800]">{t('bonuses.dailyBonus')}</p>
                        </div>
                        <img onLoad={() => setImageLoaded(imageLoaded + 1)} src={require("../../assets/images/daily.png")} className="w-[auto] h-[auto] max-h-[250px]" />
                    </div>
                    <p className="text-[#B3BEC1] md:text-[18px] text-[12px] font-[500] px-[10px]">{t('bonuses.dailyDesc')}</p>
                </button>
                <button onClick={() => { onClaimHourlyBonus() }} className="bg-bonus-bg bg-cover bg-center bg-no-repeat rounded-[25px] p-[10px] flex flex-col" >
                    <div className="flex  justify-center flex-wrap">
                        <div className="flex  justify-around flex-col px-[10px]">
                            <p className="text-[#0086D3] md:text-[20px] text-[12px] font-[500] ">{t('bonuses.everyHour')}</p>
                            <p className="text-[#fff] md:text-[30px] text-[18px] font-[800] ">{t('bonuses.hourlyBonus')}</p>
                        </div>
                        <img onLoad={() => setImageLoaded(imageLoaded + 1)} src={require("../../assets/images/spiner.png")} className="w-[auto] h-[auto]  max-h-[250px]" />
                    </div>
                    <p className="text-[#B3BEC1] md:text-[18px] text-[12px] font-[500] px-[10px]">{t('bonuses.hourlyDesc')}</p>
                </button>
            </div>
            <DailyPopup isEligable={dailyEligableData?.eligible || false} reason={dailyEligableData?.reason} isOpen={dailyBonusPopupVisible} onClose={() => { setDailyBonusPopupVisible(false) }} />
            <HourlyPopup isEligable={hourlyEligableData?.eligible || false} reason={hourlyEligableData?.reason || ""} isOpen={hourlyBonusPopupVisible} onClose={() => { setHourlyBonusPopupVisible(false) }} bonusData={getBonusData} />
        </div>
    )
}

export default Bonuses
